module.exports = __webpack_public_path__ + "img/icono-experiencia-4.79aeea18.svg";